import { storedAttributeProps } from "../html-attributes";
import { Hr } from "@react-email/components";
import { getDividerStyles } from "./styles";
export function dividerEmailRenderer(attrs: Record<string, unknown>) {
  return <Hr {...storedAttributeProps(attrs)} style={getDividerStyles(attrs)} />;
}